<template>
    <div class="info-popup">

        <el-popover
            placement="top"
            :width="350"
            :title="title"
            :visible-arrow="false"
            :popper-class="`smr-popper smr-popper--dark-title smr-popper--no-border-title`"
            trigger="click"
            v-model="popperOpen"
            @show="popperShowHandler"
            @hide="popperHideHandler"
        >
            <div class="smr-popper__close smr-popper__close--show-always" @click="popperCloseClickHandler">
                <icon><IconClose/></icon>
            </div>
            <div class="info-popup__text copy" v-html="text"></div>
            <div slot="reference">
                <div class="info-popup__toggle copy-light-small">
                    <Icon class="info-popup__icon">
                        <IconInfo />
                    </Icon>
                </div>
            </div>
        </el-popover>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Icon from '@/components/Icon.vue'
import IconInfo from '@/components/icons/IconInfo.vue'
import IconClose from '@/components/icons/IconClose.vue'

export default {
    components: {
        Icon,
        IconInfo,
        IconClose,
    },
    props: {
        title: {
            type: String
        },
        text: {
            type: String,
        }
    },
    data() {
        return {
            popperOpen: false,
        }
    },
    computed: {
        ...mapGetters(['mobile']),
    },
    methods: {
        popperShowHandler() {
            if(this.mobile) {
                this.$store.commit('setDim', true)
            }
        },
        popperHideHandler() {
            if(this.mobile) {
                this.$store.commit('setDim', false)
            }
        },
        popperCloseClickHandler() {
            this.popperOpen = false;
        },
    }
}
</script>

<style lang="scss">
.info-popup {
    &__toggle {
        @include flex-center;
        width: 18px;
        height: 18px;
        border: 2px solid currentColor;
        border-radius: 100%;
    }
    &__icon {
        width: 12px;
        height: 12px;
        cursor: pointer;
    }

    &__text {
        word-break: initial;
        text-align: left;
        padding: 0 0 12px;
    }
}
</style>